import Mapbox from 'components/base/MapBox';
import { Col, Row } from 'react-bootstrap';
import HelpCenter from '../default/address/HelpCenter';
import QueryForm from '../default/address/QueryForm';
import Map from 'assets/img/icons/map.png';
import kuwait from 'assets/img/icons/kuwait.png';

const AddressSection = () => {
  return (
    <section className="pb-5 pb-xl-5">
      <div className="container-small px-lg-7 px-xxl-3">
        <div className="text-center mb-7" id="our-location">
          <h2 className="mb-2">Built in Kuwait, for Kuwait</h2>
        </div>
        <div className="mb-15">
          {/* <Mapbox
            className="rounded-4"
            style={{ height: 380 }}
            options={{
              center: [47.9751, 29.378],
              zoom: 11,
              scrollZoom: true
            }}
          /> */}
          {/* <img src={Map} alt="map" className="w-100 rounded-4" /> */}
          <img src={kuwait} alt="map" className="w-100 rounded-4" />
        </div>
        <div className="text-center mb-7" id="contact">
          <h2 className="mb-2">Contact us</h2>
        </div>
        <Row className="g-5 g-lg-5">
          <Col
            xs={12}
            md={6}
            className="mb-5 mb-md-0 text-center text-md-start"
          >
            <HelpCenter />
          </Col>
          <Col xs={12} md={6} className="text-center text-md-start">
            <QueryForm />
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default AddressSection;
